import { render, staticRenderFns } from "./Detect.List.vue?vue&type=template&id=5ec57366&"
import script from "./Detect.List.vue?vue&type=script&lang=js&"
export * from "./Detect.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports